export const BM_UTM_KEYS = [
  'bm_utm_campaign',
  'bm_utm_source',
  'bm_utm_medium',
  'bm_utm_term',
  'bm_utm_content',
  'bm_first_utm_campaign',
  'bm_first_utm_source',
  'bm_first_utm_medium',
  'bm_first_utm_term',
  'bm_first_utm_content',
] as const

export type TUtmKey = (typeof BM_UTM_KEYS)[number]
